import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServiceChangeRequest } from './service-change-request.model';
import * as ServiceChangeRequestActions from './service-change-request.actions';

export const serviceChangeRequestsFeatureKey = 'serviceChangeRequests';

export interface State extends EntityState<ServiceChangeRequest> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceChangeRequest> = createEntityAdapter<ServiceChangeRequest>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceChangeRequestActions.addServiceChangeRequest,
    (state, action) => adapter.addOne(action.serviceChangeRequest, state)
  ),
  on(ServiceChangeRequestActions.upsertServiceChangeRequest,
    (state, action) => adapter.upsertOne(action.serviceChangeRequest, state)
  ),
  on(ServiceChangeRequestActions.addServiceChangeRequests,
    (state, action) => adapter.addMany(action.serviceChangeRequests, state)
  ),
  on(ServiceChangeRequestActions.upsertServiceChangeRequests,
    (state, action) => adapter.upsertMany(action.serviceChangeRequests, state)
  ),
  on(ServiceChangeRequestActions.updateServiceChangeRequest,
    (state, action) => adapter.updateOne(action.serviceChangeRequest, state)
  ),
  on(ServiceChangeRequestActions.updateServiceChangeRequests,
    (state, action) => adapter.updateMany(action.serviceChangeRequests, state)
  ),
  on(ServiceChangeRequestActions.deleteServiceChangeRequest,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceChangeRequestActions.deleteServiceChangeRequests,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceChangeRequestActions.loadServiceChangeRequests,
    (state, action) => adapter.setAll(action.serviceChangeRequests, state)
  ),
  on(ServiceChangeRequestActions.clearServiceChangeRequests,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
